import type { InputHTMLAttributes, ReactElement } from 'react';

import { cn } from '../lib/cn.js';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = ({ className, type = 'text', ...props }: InputProps): ReactElement => (
  <input
    type={type}
    className={cn(
      'flex h-11 sm:h-10 w-full rounded-(--radius-lg) border border-border-strong bg-surface-3 px-3 py-2 text-base sm:text-sm text-text-primary placeholder:text-text-tertiary',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:border-primary',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  />
);
